document.addEventListener("DOMContentLoaded", function () {
  // Change button add to cart if product has uniq size.
  const selectorBoxes = document.querySelectorAll(".product-form__variant-selector-boxes")[0]
  const chooseSizeBtn = document.querySelectorAll(".select-size")[0]
  const addToCartBtn = document.querySelectorAll(".uniq-size")[0]
  const selectorBox = selectorBoxes.children[0].getAttribute("data-option")
  if (selectorBox == "UNIC") {
    chooseSizeBtn.classList.add("hidden")
    addToCartBtn.classList.remove("hidden")
    const checkoutBtn = document.querySelectorAll(`[data-trigger=product-form__radios-item-trigger-UNIC]`)
    checkoutBtn[0].click()
  }
})

function getVariant(event, availableSize) {
  const selectors = event.target
    .closest(".product-form__variant-selector-boxes ")
    .querySelectorAll(".product-form__variant-selector-box")
  selectors.forEach((selector) => {
    selector.classList.remove("underline_active")
  })

  if (!availableSize) {
    return null
  }

  const selectedSize = event.target.getAttribute("data-option")
  event.target.classList.remove("underline_active")
  const escapedSize = CSS.escape(selectedSize)
  const test = document.querySelectorAll(`[data-trigger=product-form__radios-item-trigger-${escapedSize}]`)
  test[0].click()
  event.target.classList.add("underline_active")
}

function scrollToRecommendations() {
  const productRecommendationsSection = document.getElementById("product-recommendation")
  const targetOffset = productRecommendationsSection.getBoundingClientRect().top + window.scrollY
  const adjustedScrollY = targetOffset - 100

  window.scrollTo({
    top: adjustedScrollY,
    behavior: "smooth",
  })
}
